import st_upload_h5 from './st_upload.h5'

export default st_upload_h5